export default __webpack_public_path__ + "static/media/noun_Plus_2190.06a63ba9.png";